import { useRef } from 'react';
import { Drawer, useMediaQuery, Backdrop, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLayersDrawerState } from 'features/mapping/hooks/useLayersDrawerState';
import { BlockingBottomSheet } from 'components/BlockingBottomSheet';
import { MOBILE_LAYER_DRAWER_HEIGHT_USER } from 'features/mapping/mapping.constants';
import { useMapBaseLayerCommandPaletteActions } from 'hooks/commandPaletteActions';
import { DrawerContent } from './DrawerContent';
import { useLayersDrawerStyles } from './layersDrawer.styles';

export const LayersDrawer = (): JSX.Element => {
  const { classes } = useLayersDrawerStyles();
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down('phone'));
  const contentRef = useRef<HTMLDivElement | null>(null);
  const { t } = useTranslation();
  const { open: isDrawerOpen, closeLayersDrawer } = useLayersDrawerState();
  useMapBaseLayerCommandPaletteActions();

  const handleClose = (): void => {
    if (contentRef.current) {
      contentRef.current.scrollIntoView();
    }
    closeLayersDrawer();
  };

  if (isPhone) {
    return (
      <BlockingBottomSheet
        id="layers-bottom-sheet"
        open={isDrawerOpen}
        onDismiss={handleClose}
        skipInitialTransition
        snapPoints={(): number[] => [MOBILE_LAYER_DRAWER_HEIGHT_USER]}
        expandOnContentDrag
        header
        scrollLocking
        aria-label={t('map.layers.accessibility.layersDrawer')}
      >
        <DrawerContent ref={contentRef} />
      </BlockingBottomSheet>
    );
  }

  return (
    <>
      <Backdrop
        open={isDrawerOpen}
        onClick={handleClose}
        className={classes.backdrop}
      />

      <Drawer
        className={classes.drawer}
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor="right"
        open={isDrawerOpen}
        onClose={handleClose}
        variant="persistent"
        PaperProps={{
          'aria-label': t('map.layers.accessibility.layersDrawer'),
        }}
      >
        <DrawerContent />
      </Drawer>
    </>
  );
};
